import { render, staticRenderFns } from "./contentCardBaseG.vue?vue&type=template&id=062336c4&scoped=true"
import script from "./contentCardBaseG.vue?vue&type=script&lang=js"
export * from "./contentCardBaseG.vue?vue&type=script&lang=js"
import style0 from "./contentCardBaseG.vue?vue&type=style&index=0&id=062336c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062336c4",
  null
  
)

export default component.exports